import md5 from 'md5';

// Cache to store Gravatar existence status
const gravatarCache = new Map();

export const getGravatarUrl = (email, hasProfilePhoto = false) => {
  // If the user already has a profile photo, don't use Gravatar
  if (hasProfilePhoto) return null;
  
  // If no email is provided, return null
  if (!email) return null;
  
  const hash = md5(email.toLowerCase().trim());
  
  // Return a Gravatar URL with the mystery person fallback
  return `https://www.gravatar.com/avatar/${hash}?d=mp&s=200`;
};

export const checkGravatarExists = async (email) => {
  if (!email) return false;

  // Return cached result if available
  if (gravatarCache.has(email)) {
    return gravatarCache.get(email);
  }

  // Set a temporary value to prevent multiple checks
  gravatarCache.set(email, false);

  try {
    // Use a different approach to check if Gravatar exists without causing 404 errors
    // We'll use a tiny image and check its content to determine if it's the default image
    const hash = md5(email.toLowerCase().trim());
    
    // Create an image element to load the Gravatar
    const img = new Image();
    
    // Create a promise to handle the image loading
    const exists = await new Promise((resolve) => {
      img.onload = () => {
        // If the image is loaded successfully, resolve with true
        resolve(true);
      };
      
      img.onerror = () => {
        // If there's an error loading the image, resolve with false
        resolve(false);
      };
      
      // Set the source to load the image (using retro default to avoid 404s)
      img.src = `https://www.gravatar.com/avatar/${hash}?d=retro&s=1`;
    });
    
    gravatarCache.set(email, exists);
    return exists;
  } catch (error) {
    console.log('Error checking Gravatar:', error);
    gravatarCache.set(email, false);
    return false;
  }
};

export const clearGravatarCache = () => {
  gravatarCache.clear();
};

export const uploadAvatar = async (file) => {
  const formData = new FormData();
  formData.append('file', file);

  try {
    const token = localStorage.getItem('token');
    const response = await fetch('/upload', {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`
      },
      body: formData,
    });

    if (!response.ok) {
      throw new Error('Upload failed');
    }

    const data = await response.json();
    return data.url;
  } catch (error) {
    console.error('Error uploading file:', error);
    throw error;
  }
};
